import React, { FC } from 'react';
import './signup_user.scss';
import { SignUpForm } from './form/SignUpForm';
import { PageContainer } from '../../../components/page-container/PageContainer';
import { Page } from '../../../components/page/Page';
import { SignUpLayout } from './SignUpLayout';
import { SignUpDiscoveryFromHome } from './discovery/SignUpDiscoveryFromHome';

export const SignUpUserFromHome: FC = () => (
  <SignUpLayout>
    <PageContainer classNames="signup-user">
      <Page>
        <div className="signup-user__discovery">
          <SignUpDiscoveryFromHome />
        </div>
        <div className="signup-user__form">
          <SignUpForm />
        </div>
      </Page>
    </PageContainer>
  </SignUpLayout>
);
